import ServicePrime from"./ServicePrime";export default ServicePrime;